import { Injectable } from '@angular/core';
import { Theme } from '../../../../src/app/shared/services/theme.service';
import {UserApplicationModel} from "../../../api/src/applications/application.model";

export interface AppOptions {
  appCode: number | string;
  appName: 'semux' | 'dcmonitor' | 'admin' | 'app' | 'building';
  eventsLog: {objects: boolean; units: boolean; places: boolean};
  appConfig: {
    mainDashboard?: number;
    logoUrl?: string;
    mainBackgroundUrl?: string;
    typeOfDefaultUrl: 'static'|'dynamic';
    defaultUrl?: string;
  };
  charts: {
    groupBy: 'sensorLocation' | 'controller';
    parameters: boolean;
    objects: boolean;
    events: boolean;
    dashboards: boolean;
  };
  themes?: Theme[];
  userApp?: UserApplicationModel;
}
@Injectable({
  providedIn: 'root'
})
export class ConfigureService {
   constructor(public options: AppOptions) { }
}
